import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, Printer } from "lucide-react";
import { API_BASE } from "@/lib/api";

export default function PdfPreviewDialog({ open, onOpenChange, path, filename = "document.pdf", title = "Aperçu avant impression" }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!open || !path) { setUrl(null); return; }
    let obj;
    const token = localStorage.getItem("omnibat_token");
    fetch(`${API_BASE}${path}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.blob()).then((b) => { obj = URL.createObjectURL(b); setUrl(obj); });
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [open, path]);

  const download = () => { const a = document.createElement("a"); a.href = url; a.download = filename; a.click(); };
  const doPrint = () => { const w = window.open(url); if (w) w.addEventListener("load", () => w.print()); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[95vh] overflow-hidden">
        <DialogHeader><DialogTitle className="font-head">{title}</DialogTitle></DialogHeader>
        <div className="h-[72vh] rounded-lg border overflow-hidden bg-slate-100">
          {url ? <iframe title="preview" src={url} className="w-full h-full" data-testid="pdf-preview-frame" />
            : <div className="flex items-center justify-center h-full text-slate-400 text-sm">Chargement de l'aperçu…</div>}
        </div>
        {url && <a href={url} target="_blank" rel="noreferrer" className="text-xs text-brand-600 hover:underline mt-1" data-testid="preview-open-tab">L'aperçu ne s'affiche pas ? Ouvrir dans un nouvel onglet</a>}
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={doPrint} disabled={!url} data-testid="preview-print"><Printer className="h-4 w-4 mr-1.5" />Imprimer</Button>
          <Button onClick={download} disabled={!url} data-testid="preview-download" className="bg-brand-600 hover:bg-brand-700 text-white"><Download className="h-4 w-4 mr-1.5" />Télécharger</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
